import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';
import DateInput from '../common/extended_property/dateInput';
import TimeInput from '../common/extended_property/timeInput';

class ModalEdit extends Component {
  constructor(props) {
    super(props);
  }

  onChangeNumber = e => {
    const re = /^[0-9\b]+$/;
    if(e.target.value !== '' && !re.test(e.target.value)) {
      return;
    }

    this.props.handleChange(e);
  };

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal workingshiftgroup-container-modal` 
          : `container-modal ffd-container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.config.id ? 
            this.props.language.account.workingShiftGroup.editModalTitle : 
            this.props.language.account.workingShiftGroup.createModalTitle}
          </h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {`codGroup${item.messageCode}` in this.props.language.error ? 
                  this.props.language.error[`codGroup${item.messageCode}`] : 
                  this.props.language.error[`cod${item.messageCode}`]
                }{' '}
              </p>
            ))}
          {this.props.statusSave 
              && this.props.statusSave !== 200 
              && this.props.statusSave !== 500 && (  
            <p className="error">
              {props.language.error["apiErrorForm"]}{' '}
            </p>
          )}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.statusSave != 200 && (
          <div className={`box-modal max500`}>
            <section id="modal-edit" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.name} <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input type="hidden" defaultValue={this.props.config.id} id="id" />
                  <input
                    data-update="alias"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.alias ? this.props.config.alias : ""}
                    type="text"
                    placeholder={this.props.language.account.workingShiftGroup.form.namePlaceholder}
                    className="modal-input"
                  />
                </div>
              </div>
              {(this.props.activeViews.includes('ffdpvt') 
                  && this.props.permits.includes('ffdpvt')) && (
                <div className="box-form islabel">
                  <div>
                    <label className="modal-label">
                      {this.props.language.account.workingShiftGroup.form.type}
                    </label>
                  </div>
                  <div className="wrapper-check-shift-type">
                    <label className="modal-label">
                      {this.props.language.account.workingShiftGroup.form.typeInfo}
                    </label>
                    <label className="modal-label container-checkbox">
                      <input
                        data-update="isDynamicShift"
                        onChange={this.props.handleChange}
                        checked={this.props.config.isDynamicShift}
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {this.props.language.account.workingShiftGroup.dynamicWorkingShift}{' '}
                      <span className="help bottom-left">
                        <i className="fas fa-question-circle" />
                        <div>{this.props.language.account.workingShiftGroup.form.typeHelp}</div>
                      </span>
                    </label>
                  </div>
                </div>
              )}
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.workingShiftStructureDays} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.workingShiftGroup.form.workingShiftStructureDaysHelp}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="quantityDays"
                    onChange={this.onChangeNumber}
                    autoComplete="off"
                    value={this.props.config.quantityDays ? this.props.config.quantityDays : ""}
                    type="text"
                    className="modal-input"
                    placeholder={this.props.language.account.workingShiftGroup.form.workingShiftStructureDaysPlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
              <div className="box-form islabel working-shift-group-planification">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.planification} <strong>(*)</strong>{' '}
                    <span className="help display-block-help">
                      <i className="fas fa-question-circle" />
                      <div>
                        <p>{this.props.language.account.workingShiftGroup.form.planificationHelp}</p>
                        <p><i>{this.props.language.account.workingShiftGroup.form.planificationHelp2}</i></p>
                      </div>
                    </span>
                  </label>
                </div>
                <div className="table-container">
                  <div className="line-decorator"/>
                  <table className="table-header">
                    <thead>
                      <tr>
                        <th className="bd center days-th">
                          {this.props.language.account.workingShiftGroup.form.planificationTable.days}
                        </th>
                        <th className="bd left working-day-type-th">
                          {this.props.language.account.workingShiftGroup.form.planificationTable.workingDayType}
                        </th>
                        <th className="bd center start-time-th">
                          {this.props.language.account.workingShiftGroup.form.planificationTable.startTime}
                        </th>
                        <th className="bd center end-time-th">
                          {this.props.language.account.workingShiftGroup.form.planificationTable.endTime}
                        </th>
                      </tr>      
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                  <div className="scroll-table-body">
                    <table className="table-body">
                      <thead>
                        <tr>
                          <th className="bd center days-th"></th>
                          <th className="bd left working-day-type-th"></th>
                          <th className="bd center start-time-th"></th>
                          <th className="bd center end-time-th"></th>
                        </tr>      
                      </thead>
                      <tbody>
                      {
                        this.props.config.planning && this.props.config.planning.map((item,index) => {
                          return (
                            <tr key={index}>
                              <td className="bd center days-th">{item.dayNumber}</td>
                              <td className="bd left working-day-type-th">
                                <div className={"radio-buttons-container"}>
                                  <label className="modal-label container-checkbox">
                                    <input
                                      data-update={"hasShiftTrue_" + index}
                                      onChange={this.props.handleChange}
                                      checked={item.hasShift}
                                      type="radio"
                                    />
                                    <span className="checkmark radio" />
                                    {this.props.language.account.workingShiftGroup.form.planificationTable.workType}
                                  </label>
                                  <label className="modal-label container-checkbox">
                                    <input
                                      data-update={"hasShiftFalse_" + index}
                                      onChange={this.props.handleChange}
                                      checked={!item.hasShift}
                                      type="radio"
                                    />
                                    <span className="checkmark radio" />
                                    {this.props.language.account.workingShiftGroup.form.planificationTable.restType}
                                  </label>
                                </div>
                              </td>
                              <td className="bd center start-time-th">
                                <TimeInput
                                  date={item.startTime ? "2000-01-01 " + item.startTime + ":00" : "" }
                                  dataUpdate={"startTime_" + index}
                                  onChange={this.props.handleChange}
                                  placeholder={this.props.language.account.workingShiftGroup.form.planificationTable.hourPlaceholder}
                                  disabled={!item.hasShift}
                                />
                              </td>
                              <td className="bd center end-time-th">
                                <TimeInput
                                  date={item.endTime ? "2000-01-01 " + item.endTime + ":00" : "" }
                                  dataUpdate={"endTime_" + index}
                                  onChange={this.props.handleChange}
                                  placeholder={this.props.language.account.workingShiftGroup.form.planificationTable.hourPlaceholder}
                                  disabled={!item.hasShift}
                                />
                              </td>
                            </tr>
                          );
                        })
                      }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.workingShiftStartDate} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.workingShiftGroup.form.workingShiftStartDateHelp}</div>
                    </span>
                  </label>
                </div>
                <div className="flex">
                  <DateInput
                    date={this.props.config.shiftStart && this.props.config.shiftStart!="" ? 
                      this.props.config.shiftStart : ""
                    }
                    dataUpdate="shiftStart"
                    onChange={this.props.handleChange}
                    normalDateDisplay={true}
                    placeholder={this.props.language.account.workingShiftGroup.form.workingShiftStartDatePlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.allowedTimeFFD} <strong>(*)</strong>{' '}
                    <span className="help display-block-help bottom-left">
                      <i className="fas fa-question-circle" />
                      <div>
                        <p>{this.props.language.account.workingShiftGroup.form.allowedTimeFFDHelp}</p>
                        <p><i>{this.props.language.account.workingShiftGroup.form.allowedTimeFFDHelp2}</i></p>
                      </div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="maxTimeToSendReportInMinutes"
                    onChange={this.onChangeNumber}
                    autoComplete="off"
                    value={this.props.config.maxTimeToSendReportInMinutes ? this.props.config.maxTimeToSendReportInMinutes : ""}
                    type="text"
                    className="modal-input"
                    placeholder={this.props.language.account.workingShiftGroup.form.allowedTimeFFDPlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.maxLateTimeFFD} <strong>(*)</strong>{' '}
                    <span className="help display-block-help top-left">
                      <i className="fas fa-question-circle" />
                      <div>
                        <p>{this.props.language.account.workingShiftGroup.form.maxLateTimeFFDHelp}</p>
                        <p><i>{this.props.language.account.workingShiftGroup.form.maxLateTimeFFDHelp2}</i></p>
                      </div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="maxTimeToGradeAfterInMinutes"
                    onChange={this.onChangeNumber}
                    autoComplete="off"
                    value={this.props.config.maxTimeToGradeAfterInMinutes ? this.props.config.maxTimeToGradeAfterInMinutes : ""}
                    type="text"
                    className="modal-input"
                    placeholder={this.props.language.account.workingShiftGroup.form.maxLateTimeFFDPlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.maxAdvanceTimeFFD} <strong>(*)</strong>{' '}
                    <span className="help display-block-help top-left">
                      <i className="fas fa-question-circle" />
                      <div>
                        <p>{this.props.language.account.workingShiftGroup.form.maxAdvanceTimeFFDHelp}</p>
                        <p><i>{this.props.language.account.workingShiftGroup.form.maxAdvanceTimeFFDHelp2}</i></p>
                      </div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="maxTimeToGradeBeforeInMinutes"
                    onChange={this.onChangeNumber}
                    autoComplete="off"
                    value={this.props.config.maxTimeToGradeBeforeInMinutes ? this.props.config.maxTimeToGradeBeforeInMinutes : ""}
                    type="text"
                    className="modal-input"
                    placeholder={this.props.language.account.workingShiftGroup.form.maxAdvanceTimeFFDPlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.workingShiftGroup.form.mailRecipients} <strong>(*)</strong>{' '}
                    <span className="help display-block-help top-left">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.workingShiftGroup.form.mailRecipientsHelp}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="mailRecipients"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.mailRecipients ? this.props.config.mailRecipients : ""}
                    type="text"
                    className="modal-input"
                    placeholder={this.props.language.account.workingShiftGroup.form.mailRecipientsPlaceholder}
                    disabled={this.props.config.isDynamicShift}
                  />
                </div>
              </div>
            </section>
          </div>
        )}
        {this.props.statusSave != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.props.handleSubmit}
                  type="button"
                  value={this.props.config.id ? 
                    this.props.language.account.workingShiftGroup.buttonEdit :
                    this.props.language.account.workingShiftGroup.buttonCreate}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500`}>
            <section
              className={'feed-back green'}
            >
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>{this.props.config.id ? 
                  this.props.language.account.workingShiftGroup.feedBackOkEdit :
                  this.props.language.account.workingShiftGroup.feedBackOkCreate}</p>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default ModalEdit;



// WEBPACK FOOTER //
// ./source/client/components/account_working_shift_group/modalEdit.jsx